/**
 * Notifications API – list and mark as read (e.g. mention notifications).
 */

import apiClient, { TokenManager } from '../../../../shared/lib/apiClient';

export interface Notification {
  notification_id: string;
  user_id: string;
  type: string;
  title: string;
  body: string;
  project_id: string;
  project_name?: string;
  target_type?: string;
  target_uiid?: string;
  target_name?: string;
  comment_id?: string;
  source_user_id?: string;
  source_user_name?: string;
  read: boolean;
  created_at: string;
}

export interface ListNotificationsResponse {
  notifications: Notification[];
  unread_count: number;
}

export async function listNotifications(
  limit: number = 50
): Promise<ListNotificationsResponse> {
  const userId = TokenManager.getUserId();
  if (!userId) {
    throw new Error('User ID is required to load notifications');
  }
  const params = new URLSearchParams({
    user_id: userId,
    limit: String(limit),
  });
  return apiClient<ListNotificationsResponse>(
    `/notifications?${params.toString()}`,
    {
      method: 'GET',
      requireAuth: true,
      redirectToLoginOn401: false,
    }
  );
}

export async function markNotificationRead(
  notificationId: string
): Promise<{ status: string; notification_id: string }> {
  const userId = TokenManager.getUserId();
  if (!userId) {
    throw new Error('User ID is required to mark notifications read');
  }
  const params = new URLSearchParams({ user_id: userId });
  return apiClient<{ status: string; notification_id: string }>(
    `/notifications/${encodeURIComponent(notificationId)}/read?${params.toString()}`,
    {
      method: 'PATCH',
      requireAuth: true,
      redirectToLoginOn401: false,
    }
  );
}
